import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import numeral from 'numeral'
import { FaAngleRight, FaRegEdit } from 'react-icons/fa'
import { AiOutlineEye } from 'react-icons/ai'

import { status, allStatus } from '../constants'
import { Button } from '../../../../buttons'
import { FONTS } from '../../../../../constants'
import { getExcludeVat, getIncludeVat, getVat } from '../../../../../function/billing'

export const BillingItem = React.memo(({
  item,
  index,
  expand,
  isEditList,
  // activeItem,
  handleExpand,
  handleClickView,
  handleClickEdit,
  // handleClickRow,
  interpretBillingType,
}) => {
  const handleClickButton = e => {
    if (item.status === allStatus.PLANNING || item.status === allStatus.DELIVERED) {
      handleClickEdit(index)
    } else {
      handleClickView(index)
    }
    e.stopPropagation()
  }

  const excludeVat = getExcludeVat(item)
  const vatPrice = getVat(item)
  const includeVat = getIncludeVat(item)
  const _status = status[item.status]

  return (
    <Root>
      <Wrapper>
        <HeaderWrapper
          active={ expand[index] }
          onClick={ () => handleExpand(index) }
        >
          <AngleCol>
            <FaAngleRight id='arrow' style={ { color: '#2D9CDB', fontSize: 16 } } />
          </AngleCol>
          <MilestoneCol>
            <Number>{ item.billing_no }</Number>
          </MilestoneCol>
          <ProcessCol>
            <NameText>
              { item.name }
              <div id='tooltip-name'>{ item.name }</div>
            </NameText>
          </ProcessCol>
          <ValueCol>
            <VatCol>
              <Col>
                <Title>Exc. VAT</Title>
                <NumberBold>฿ { excludeVat }</NumberBold>
              </Col>
            </VatCol>
            <VatCol>
              <Col>
                <Title>VAT</Title>
                <NumberBold>฿ { vatPrice }</NumberBold>
              </Col>
            </VatCol>
            <VatCol>
              <Col>
                <Title>Inc. VAT</Title>
                <NumberBold>฿ { includeVat }</NumberBold>
              </Col>
            </VatCol>
          </ValueCol>
          <DateCol>
            <Number>{ item.invoice_date ? moment(item.invoice_date).format('DD/MM/YYYY') : '-' }</Number>
          </DateCol>
          <StatusCol>
            <StatusWrapper status={ _status.value }>
              <Dot status={ _status.value } />
              { _status.label }
            </StatusWrapper>
          </StatusCol>
          <ButtonWrapper>
            { (item.status === allStatus.PLANNING || item.status === allStatus.DELIVERED) ?
              <Button
                width='70px'
                height='26px'
                theme='#28a745'
                disabled={ !isEditList }
                onClick={ handleClickButton }
                icon={ <FaRegEdit style={ { fontSize: 16, pointerEvents: 'none' } } /> }
              >
              Edit
              </Button>
              :
              <Button
                outline
                width='70px'
                height='26px'
                theme='#428BCA'
                disabled={ !isEditList }
                onClick={ handleClickButton }
                icon={ <AiOutlineEye style={ { fontSize: 16, pointerEvents: 'none' } } /> }
              >
                View
              </Button>
            }
          </ButtonWrapper>
        </HeaderWrapper>
        { expand[index] &&
        <DetailWrapper>
          {item.billing_types.map((i, key) => {
            const _type = i.type ? interpretBillingType.find(t => t.label === i.label) : null
            return (
              <div key={ key }>
                <DetailItem>
                  <div />
                  <div />
                  <DetailCol>
                    <Title>Type</Title>
                    <Text>
                      { _type ? _type.label : '-' }
                      <div id='tooltip-type'>{ _type ? _type.label : '-' }</div>
                    </Text>
                  </DetailCol>
                  <ValueCol>
                    <NumberCol>
                      <Col>
                        <Title>Value</Title>
                        <Number>{`฿ ${numeral(i.price).format('0,0.00')}`}</Number>
                      </Col>
                    </NumberCol>
                  </ValueCol>
                </DetailItem>
              </div>
            )
          })}
        </DetailWrapper>
        }
      </Wrapper>
    </Root>
  )
})

const Root = styled.div`
  overflow: hidden;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const HeaderWrapper = styled.div`
  min-height: 68px;
  display: grid;
  grid-template-columns: 30px 50px 200px 9fr 2fr 2fr 2fr;
  grid-gap: 24px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
  cursor: pointer;
  background: #FFFFFF;
  padding: 0 24px;

  #arrow {
    transform: ${p => (p.active ? 'rotate(90deg)' : 'rotate(0deg)')};
    transition: all 0.3s;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 30px 50px 100px 9fr 1fr 2fr 1fr;
  }
`

const DetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const DetailItem = styled.div`
  height: 58px;
  display: grid;
  grid-template-columns: 30px 50px 200px 9fr 2fr 2fr 2fr;
  grid-gap: 24px;
  border-bottom: 1px solid #FFFFFF;
  background: #F1F1F1;
  padding: 0 24px;

  @media (max-width: 1024px) {
    grid-template-columns: 30px 50px 100px 9fr 1fr 2fr 1fr;
  }
`

const MilestoneCol = styled.div`
  display: flex;
  align-items: center;
`

const ProcessCol = styled(MilestoneCol)`
  position: relative;
  /* overflow: hidden; */

  #tooltip-name {
    position: fixed;
    max-width: 300px;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    color: #808080;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
    white-space: normal;
    z-index: 1;
  }

  #tooltip-name::after {
    position: absolute;
    bottom: 100%;
    left: 50%;
  }

  :hover {
    #tooltip-name {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
  }
`

const ValueCol = styled.div`
  display: flex;
  margin-left: 24px;
`

const NumberCol = styled(MilestoneCol)`
  word-break: break-all;
  padding-right: 32px;

  @media (max-width: 1024px) {
    max-width: 140px;
  }
`

const VatCol = styled(NumberCol)`
  flex: 1;
`

const DateCol = styled(MilestoneCol)`
`

const StatusCol = styled(MilestoneCol)`
`

const AngleCol = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

const ButtonWrapper = styled(MilestoneCol)`
  justify-content: flex-end;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  flex: 1;
`

const DetailCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  #tooltip-type {
    position: fixed;
    max-width: 300px;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    color: #808080;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
    white-space: normal;
    z-index: 1;
  }

  #tooltip-type::after {
    position: absolute;
    bottom: 100%;
    left: 50%;
  }

  :hover {
    #tooltip-type {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
  }
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #C4C4C4;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`

const NameText = styled(Text)`
  position: relative;
  display: block;
`

const Number = styled.span`
  font-family: ${FONTS.NOTOSANS};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const NumberBold = styled(Number)`
  font-family: ${FONTS.NOTOSANS_MEDIUM};
`

const StatusWrapper = styled.div`
  min-width: 82px;
  width: fit-content;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => (p.status ? status[p.status].bg : '')};
  color: ${p => (p.status ? status[p.status].color : '')};
  border-radius: 4px;
  padding: 0 10px;
`

const Dot = styled.div`
  width: 6px;
  height: 6px;
  background: ${p => (p.status ? status[p.status].color : '')};
  border-radius: 50%;
  margin-right: 6px;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-billing/data-table/billing-item.js